import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { AuthProvider } from '@/features/auth'
import { initializeApiInterceptor } from '@/services/apiInterceptor'
import { useReloadOnNewBuild } from '@/hooks/useReloadOnNewBuild'

// Initialize API interceptor for global 401 handling and token refresh
initializeApiInterceptor()

// Every push deploys at once, but an open tab keeps the old build until it
// is closed. This reloads to the new build when the fan comes back to the
// tab (never mid-typing), so a fix is never "still not there" for them.
function BuildWatcher() {
  useReloadOnNewBuild()
  return null
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BuildWatcher />
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
)
